import React from 'react';
import PropTypes from 'prop-types';
export var Component = function Component(_ref) {
  var children = _ref.children;
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh'
    }
  }, children);
};
Component.displayName = 'Viewport';
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired
} : {};